import { createSlice } from "@reduxjs/toolkit";
import api from "../../api";
import { createAsyncThunkInstance } from "../createAsyncThunkInstance";
import { ICommonInitialState } from "../../shared/types/storeTypes";
import { ICityRequest, IApplicationStatusesResponse } from "../../api/guides/types";
import { Dictionaries, DictionaryType } from "@/model/dictionaries";

interface IGuidesState extends ICommonInitialState {
  guides: Dictionaries | null;
  cities: any;
  applicationStatuses: IApplicationStatusesResponse[];
}

const initialState: IGuidesState = {
  guides: null,
  cities: [],
  applicationStatuses: [],
  isLoading: false,
  error: null,
};

export const fetchGuides = createAsyncThunkInstance<
  Dictionaries,
  DictionaryType[]
>("guides/fetchGuides", api.guides.getGuides);

export const fetchCities = createAsyncThunkInstance<
  any,
  ICityRequest
>("guides/fetchCities", api.guides.getCities);

export const fetchApplicationStatuses = createAsyncThunkInstance<
  IApplicationStatusesResponse[],
  number
>("guides/fetchApplicationStatuses", api.guides.getApplicationStatuses);

const guidesSlice = createSlice({
  name: "guides",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGuides.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGuides.fulfilled, (state, action) => {
        state.isLoading = false;
        state.guides = action.payload;
      })
      .addCase(fetchCities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cities = action.payload;
      })
      .addCase(fetchApplicationStatuses.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchApplicationStatuses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.applicationStatuses = action.payload;
      });
  },
});

export const guidesReducer = guidesSlice.reducer;
